import FilterSelect from '../modules/filter-select';
class ProductsGrid {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.gridEl = this.root.querySelector('[products-grid-list]');
        this.filterSelectEl = this.root.querySelector('[filter-select]');
        this.filterSelectInstance = null;

        return true;
    }

    init() {
        this.setCategoryEl();
        this.setFilterSelectEl();
    }

    setCategoryEl() {
        this.categoryEl = this.root.querySelectorAll('[products-grid-cat]');
        if (!this.categoryEl) return;

        this.onCategory = this.onCategoryClick.bind(this);
        this.categoryEl.forEach(item => {
            item.removeEventListener('click', this.onCategory);
        });

        this.categoryEl.forEach(item => {
            item.addEventListener('click', event => this.onCategory(event));
        });
    }

    setFilterSelectEl() {
        if (!this.filterSelectEl) return;
        this.filterSelectInstance = new FilterSelect(
            this.filterSelectEl,
            this.root
        );

        this.root.addEventListener('filter-select-item-swap', () => {
            this.setCategoryEl();
        });
    }

    async onCategoryClick(event) {
        const { currentTarget } = event;
        const categoryID = currentTarget.getAttribute('products-grid-cat');

        this.resetCategoriesEl();
        currentTarget.classList.add('-active');

        await this.loadProducts(categoryID);
    }

    async loadProducts(categoryID) {
        const formData = new FormData();
        if (categoryID) formData.append('category', categoryID);

        const request = await fetch(`${home_url}/wp-json/products/v1/get`, {
            method: 'POST',
            body: formData,
        });
        const res = await request.json();
        const { data } = res;
        const { success, html } = data;

        this.gridEl.innerHTML = html;

        setTimeout(() => {}, 4000);
    }

    resetCategoriesEl() {
        if (!this.categoryEl) return;
        this.categoryEl.forEach(item => item.classList.remove('-active'));
    }
}

const sections = document.querySelectorAll('[products-grid]');
const initProductsGrid = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new ProductsGrid(el);
    });
};

initProductsGrid(sections);
